import { Component, OnInit } from '@angular/core';
import { FullSpinnerService } from '../../../services/full-spinner.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { ThOrderingComponent } from '../../shared/th-ordering/th-ordering.component';
import { ConfirmAlertComponent } from '../../shared/confirm-alert/confirm-alert.component';
import { HasPermissionDirective } from '../../../utils/has-permission.directive';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppConstants } from '../../../utils/AppConstants';
import { BaseSearchCriteria } from '../../../models/searchCriteria/BaseSearchCriteria';
import { TooltipDirective } from '../../../utils/tooltip.directive';
import { LICENSE_SEARCH_CRITERIA_KEY, LicenseSearchCriteria } from '../../../models/searchCriteria/LicenseSearchCriteria';
import { License } from '../../../models/License';
import { LicenseService } from '../../../services/license.service';
import { AlertService } from '../../shared/alert/alert.service';
import { AppEnums } from '../../../models/AppEnums';
import { StorageService } from '../../../services/storage.service';
import { FilterPanelComponent } from '../../shared/filter-panel/filter-panel.component';

@Component({
  selector: 'app-license-list',
  standalone: true,
  imports: [
    CommonModule,
    NgxPaginationModule,
    FilterPanelComponent,
    ThOrderingComponent,
    ConfirmAlertComponent,
    HasPermissionDirective,
    FormsModule,
    ReactiveFormsModule,
    TooltipDirective],
  templateUrl: './license-list.component.html',
  styleUrl: './license-list.component.scss'
})
export class LicenseListComponent implements OnInit {

  searchForm!: FormGroup;
  emptySearchCriteria: LicenseSearchCriteria = { name: undefined, pageSize: AppConstants.pageSize, pageNumber: 1 };
  searchCriteria: LicenseSearchCriteria = { ...this.emptySearchCriteria };

  licenses: License[] = [];

  selectedLicense?: License;
  totalItems: number = 0;

  showConfirmationModal: boolean = false;
  confirmationMessage: string = '';
  confirmOperationType: 'DEL' | undefined = undefined;

  constructor(
    private licenseService: LicenseService,
    private alertService: AlertService,
    private storageService: StorageService,
    private fullSpinnerService: FullSpinnerService,
    private fb: FormBuilder,
    private router: Router) {

    this.searchForm = this.fb.group({
      name: [undefined],
    });
    this.clearFilter();
    fullSpinnerService.spinner(undefined);

  }
  ngOnInit(): void {
    this.fullSpinnerService.spinner(undefined);
    if (AppConstants.storeNavigationInfo) {
      let scObj = this.storageService.retrieveNavigationInfo(LICENSE_SEARCH_CRITERIA_KEY);
      if (scObj !== null) {
        this.searchCriteria = scObj;
      }
      else
        this.storageService.saveNavigationInfo(this.searchCriteria, LICENSE_SEARCH_CRITERIA_KEY);
    }
    this.searchForm.patchValue(this.searchCriteria);
    this.find();
  }


  edit(licenseId?: number) {
    this.router.navigate(['licenses/' + licenseId]);
  }


  find() {
    this.fullSpinnerService.spinner('');
    this.storageService.saveNavigationInfo(this.searchCriteria, LICENSE_SEARCH_CRITERIA_KEY);
    this.licenseService.find(this.searchCriteria).subscribe({
      next: (res) => {
        this.licenses = res.items;
        this.totalItems = res.totalItems;
      }, complete: () => {
        this.fullSpinnerService.spinner(undefined);
      }
      , error: () => {
        this.fullSpinnerService.spinner(undefined);
      }
    });
  }

  computeTypeLicense(id: string) {
    return AppEnums.licenseTypesTypes.find(type => type.id === id)?.description
  }

  search(): void {
    this.searchCriteria = {
      ...this.searchCriteria,
      ...this.searchForm.value
    }
    this.find();
  }

  clearFilter(withSearch: boolean = false) {
    this.searchCriteria = { ...this.emptySearchCriteria };
    this.searchForm.patchValue(this.searchCriteria);
    if (withSearch)
      this.find();
  }

  pageChanged(event: number) {
    this.searchCriteria.pageNumber = event;
    this.find();
  }

  ordering(baseSearchCriteria: BaseSearchCriteria | undefined) {
    this.searchCriteria = baseSearchCriteria as LicenseSearchCriteria
    this.find();
  }


  confirmOperation(license: License, confirmOperationType: "DEL" | undefined) {
    this.showConfirmationModal = true;
    this.confirmOperationType = confirmOperationType;
    if (confirmOperationType === 'DEL') {
      this.confirmationMessage = "Eliminazione licenza - Sicuro di voler eliminare la licenza " + license.name;
    }
    this.selectedLicense = license;
  }


  cancelModalOperationExec() {
    this.selectedLicense = undefined;
    this.showConfirmationModal = false;
  }

  modalOperationExec() {
    this.fullSpinnerService.spinner('');
    if (this.confirmOperationType === 'DEL') {
      this.licenseService.delete(this.selectedLicense!.id!).subscribe({
        next: (res) => {
          this.alertService.addErrors(AppConstants.titleDeleteSuccessMessage, [AppConstants.successMessage], true);
          this.cancelModalOperationExec();
          this.fullSpinnerService.spinner(undefined);
          this.find()
        }, complete: () => {

        }
        , error: () => {
          this.cancelModalOperationExec();
          this.alertService.addErrors(AppConstants.titleErrorMessage, [AppConstants.errorMessage], true);
          this.fullSpinnerService.spinner(undefined);
        }
      });
    }
  }
}

